import type {FetchResult} from '@logistics-frontend/core/utils/network'
import {Banner} from '@logistics-frontend/types/mobile/definitions/promotions'
import {defaultTo, makeGet, map, pipe} from '@logistics-frontend/utils'

import type {PromotionsResponse} from 'src/api/cargo-c2c/types'

import {Promotion, PromotionBanner} from './AutoBanner.types'

const prependHash = (str: string) => '#' + str

const fromBannerGet = makeGet<Banner>()

const getImageTagOrUndefined = (trailIcon: Banner['layout']['trail_icon']) =>
  trailIcon && 'image_tag' in trailIcon ? trailIcon.image_tag : undefined

const toBanner = (banner: Banner): PromotionBanner => ({
  id: pipe(banner, fromBannerGet('id')),
  link: pipe(banner, fromBannerGet('action.deeplink')),
  title: pipe(banner, fromBannerGet('layout.title')),
  subtitle: pipe(banner, fromBannerGet('layout.subtitle')),
  backgroundColor: pipe(banner, fromBannerGet('layout.background.color.color_day'), defaultTo('ffffff'), prependHash),
  trailImageTag: pipe(banner, fromBannerGet('layout.trail_icon'), getImageTagOrUndefined),
  advertisementText: pipe(banner, fromBannerGet('layout.advertisement_tag.text')),
  advertisementInfo: pipe(banner, fromBannerGet('layout.advertisement_tag.info')),
})

const fromResponseGet = makeGet<PromotionsResponse>()

export const toPromotions = ({body}: FetchResult<PromotionsResponse>): Promotion => ({
  isAutoScrollEnabled: pipe(
    body, //
    fromResponseGet('banners.autoscroll_enabled'),
    Boolean,
  ),
  banners: pipe(
    body, //
    fromResponseGet('banners.banner_list'),
    map(toBanner),
  ),
})

export const stubPromotions = (): Promotion => ({
  isAutoScrollEnabled: false,
  banners: [],
})
